/**
 * ATLAS-702 Reporting - BETA Services
 * Configuration settings for the report
 */
import _ from "lodash";

const config = (context) => {
    return {
        hideListHeader: true,
        hideActionColumn: true,
        editPath: "services",
        pageTitle: "Services",
        pageIcon: "work",
        listQueryId: "searchReportServices",
        responseFieldName: "searchServices",
        deleteQueryId: "deleteService",
        linkRows: false,
        searchRecordsInput: false,
        columns: {
            processor: { label: "Processor", sortable: true },
            isIpCorp: { label: "IP Corp", sortable: true },
            isRestructured: { label: "Restructured", sortable: true },
            account: { label: "Account Name", sortable: true },
            serviceType: { label: "Service Type", sortable: true },
            merchantNumber: { label: "Merchant Number", sortable: true },
            status: { label: "Status", sortable: true },
            company: { label: "Company", sortable: true },
            portfolio: { label: "Portfolio", sortable: true },
            businessCity: { label: "Business City", sortable: true },
            proposalStatementValue: { label: "Proposal / Statement Volume", sortable: true },
            businessEmail: { label: "Business Email", sortable: true },
            approvalDate: { label: "Approval Date", sortable: true, dateFilter: true },
            dateSubmitted: { label: "Submitted To Underwriting Date", sortable: true, dateFilter: true },
            uwResult: { label: "Underwriting Outcome", sortable: true },
            dateUwResult: { label: "Underwriting Outcome Date", sortable: true, dateFilter: true },
            dateFirstProcessing: { label: "First Processing Date", sortable: true, dateFilter: true },
            closeDate: { label: "Closed Date", sortable: true, dateFilter: true },
            closeReason: { label: "Reason For Closure", sortable: true },
            closeReasonDetails: { label: "Closed Merchant Reason Detail", sortable: true }
        },
        ignoreSortColumns: [
            "processor",
            "isIpCorp",
            "isRestructured",
            "account",
            "serviceType",
            "merchantNumber",
            "status",
            "company",
            "portfolio",
            "businessCity",
            "proposalStatementValue",
            "businessEmail",
            "approvalDate",
            "dateSubmitted",
            "uwResult",
            "dateUwResult",
            "dateFirstProcessing",
            "closeDate",
            "closeReason",
            "closeReasonDetails"
        ],
        perPageOptions: [10, 20, 25, 50],
        defaults: {
            sort: "createdAt",
            sortDir: "desc",
            perPage: 10,
        },
        fuseSearch: null,
        formatResponse: (data) => {
            const services = context.$reduce(data, "searchServices.items");
            let items = [];
            if (services && services.length) {
                items = services.map((_service) => {
                    //find portfolio name portfolios object
                    let portfolioName = "";
                    if(_service.portfolios && _service.portfolios.items && _service.portfolios.items.length) {
                        console.log(_service.portfolios.items[0].portfolio.name)
                        portfolioName = _service.portfolios.items[0].portfolio.name;
                    }
                    const row = {
                        id: context.$reduce(_service, "id"),
                        processor: context.$reduce(_service, "processor"),
                        isIpCorp: context.$reduce(_service, "IPCorp"),
                        company: context.$reduce(_service, "account.company.name"),
                        account: context.$reduce(_service, "account.name"),
                        serviceType: context.$reduce(_service, "serviceType"),
                        status: context.$reduce(_service, "status"),
                        portfolio: portfolioName,
                        name: context.$reduce(_service, "name"),
                        merchantNumber: context.$reduce(_service, "merchantNumber"),
                        businessCity: (context.$reduce(_service, "addressPhysical") ? JSON.parse(context.$reduce(_service, "addressPhysical")).locality : ""),
                        businessEmail: context.$reduce(_service, "email"),
                        approvalDate: context.$reduce(_service, "approvalDate"),
                        isRestructured: context.$reduce(_service, "isRestructured") ? true : false,
                        proposalStatementValue: context.$reduce(_service, "proposalStatementValue"),
                        dateSubmitted: context.$reduce(_service, "dateSubmitted"),
                        uwResult: context.$reduce(_service, "uwResult"),
                        dateUwResult: context.$reduce(_service, "dateUwResult"),
                        dateFirstProcessing: context.$reduce(_service, "dateFirstProcessing"),
                        closeDate: context.$reduce(_service, "closeDate"),
                        closeReason: context.$reduce(_service, "closeReason"),
                        closeReasonDetails: context.$reduce(_service, "closeReasonDetails")
                    };
                    
                    // remove null values - set them to blank
                    Object.keys(row).map(_key => {
                        if (null === row[_key]) {
                            row[_key] = '';
                        }
                    });
                    
                    return row;
                });
            }

            // sort results
            const elasticListRef = context.$refs.elasticListRef;
            items = _.sortBy(items, elasticListRef.currentSort);
            if ('desc' == elasticListRef.currentSortDir) {
                return items.reverse();
            }
            return items;
        },
    };
};

export default config;
